import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// sub components
import Avatar from './Avatar';
import Profile from './Profile';
import List from './List';
import Logout from './Logout';

// styles
import * as S from './styles';

const UserMenu = ({
  user,
  customItems
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const onBodyClick = event => {
      // check if element that was clicked is inside of ref'd component
      // if so no action is required from this event listener so exit
      if (ref.current.contains(event.target)) {
        return
      }

      // else close the dropdown
      setIsOpen(false)
    }

    // add event listener
    document.body.addEventListener("click", onBodyClick)

    // CLEANUP
    // remove event listener
    return () => {
      document.body.removeEventListener("click", onBodyClick)
    }
  }, []);

  /**
   * closeMenu
   * Closes the user menu and remove document events
   */
  const closeMenu = (e) => {
    setIsOpen(false)
  }

  /**
   * toggleDropdown
   *
   * Triggers the toggle function to show/hide the dropdown menu
   */
  const toggleDropdown = (e) => {
    setIsOpen(!isOpen);
  }

  return (
    <S.UserMenu data-testid="user-menu" ref={ref}>
      <S.Trigger
        data-testid="user-menu-trigger"
        className="trigger-component"
        aria-expanded={isOpen}
        aria-label="Clique para abrir o menu de usuário"
        onClick={() => toggleDropdown()}
      >
        <Avatar name={user && user.userName} imageUrl={user && user.imageUrl} />
      </S.Trigger>

      <S.Nav data-testid="user-menu-dropdown" isOpen={isOpen}>

        <S.NavList>
          <S.NavListItem>
            <Profile data-testid="user-menu-profile" user={user} />
          </S.NavListItem>

          <S.NavListItem>
            <List data-testid="user-menu-list" onCloseMenu={closeMenu} customItems={customItems} />
          </S.NavListItem>

          <S.NavListItem>
            <Logout data-testid="user-menu-logout" />
          </S.NavListItem>
        </S.NavList>

      </S.Nav>
    </S.UserMenu>
  );
};

UserMenu.defaultProps = {
  customItems: []
}

UserMenu.propTypes = {
  user: PropTypes.object,
  customItems: PropTypes.array
};

export default UserMenu;